import React, { useState, useContext, useEffect } from "react";
import MemberProfilePage from "./Layout/MemberProfilePage";
import Messaging from "./Layout/Messaging";
import AudioCall from "./Layout/AudioCall";
import VideoCall from "./Layout/VideoCall";
import LiveStream from "./Layout/LiveStream";
import BloggingProfile from "./Layout/Blogging";
import FriendsProfile from "./Layout/Friends";
import GroupsProfile from "./Layout/Groups";
// import CollaborationProfile from "./Layout/Collaboration-bk";
import ExploreProfile from "./Layout/Explore";
import CreatePost from "./Layout/Post";
import ReelsProfile from "./Layout/Reels";
import UserPickModule from "./Layout/UserPickPage";
import ExploreLocationModule from "./Layout/ExploreLocation";
import StaySpotsModule from "./Layout/StaySpots";
import TasteTrailsModule from "./Layout/TasteTrail";
import LocalTreasureModule from "./Layout/LocalTreasure";


const MasterOperationRenderer = ({ operationType, data, profileId, mode, setShowPopup, locationId }) => {
  switch (operationType) {
    case "page":
      return <MemberProfilePage userId={data.userId} />;
    case "messaging":
      return <Messaging userId={data.userId} mode={mode}  />;
    case "audio":
      return <AudioCall userId={data.userId} mode={mode} />;
    case "video":
      return <VideoCall userId={data.userId} mode={mode} />;
    case "live":
      return <LiveStream streamId={data.streamId} mode={mode} />;
      case "blogging":      
      return <BloggingProfile userId={data.userId} profileId={profileId} />;
    case "friends":
      return <FriendsProfile userId={data.userId} profileId={profileId} setShowPopup={setShowPopup} />;
    case "groups": 
      return <GroupsProfile userId={data.userId} profileId={profileId} />;
    // case "collaboration": 
    //   return <CollaborationProfile userId={data.userId} profileId={profileId} />;
    case "explore":
      return <ExploreProfile userId={data.userId} profileId={profileId} />;
    case "post":
      return <CreatePost userId={data.userId} profileId={profileId} />;
    case "reels":
        return <ReelsProfile userId={data.userId} profileId={profileId} />;
    case "starpick": 
        // return <UserPickModule userId={data.userId} />  
        return <UserPickModule userId={data.userId} />
    case "explorelocation": 
        return <ExploreLocationModule locationId={data.locationId}/>
    case "stayspots": 
        return <StaySpotsModule locationId={data.locationId} />
    case "tastetrails": 
        return <TasteTrailsModule locationId={data.locationId} />
    case "treasure": 
        return <LocalTreasureModule locationId={data.locationId} />      
    default:
      return <div>Invalid Operation</div>;
  }
};

export default MasterOperationRenderer;
